export default __webpack_public_path__ + "static/verse-app-screenshot-56f1c74e46ec6d98a2493e4829fe6ba9.png";